import { BreadcrumbProvider } from "@/ui-components/ui/breadcrumb/breadcrumb-context";
import DynamicBreadcrumb from "@/ui-components/ui/breadcrumb/breadcrumb-url";
import GlobalSearch from "@/ui-components/ui/global-search";
import SideMenu from "@/ui-components/utils/menu-items/side-menu";
import TopBar from "@/ui-components/utils/menu-items/top-bar";
import { Calculator, PackageSearch, Trophy, User, MapPin, RefreshCw } from "lucide-react";
import { ReactElement } from "react";

const SettingsRootComponent = ({ children }: { children: ReactElement }) => {
  return (
    <div className="flex flex-col h-full">
      <BreadcrumbProvider>
        <TopBar>
          <>
            <DynamicBreadcrumb />
            <GlobalSearch />
            <div className="flex-1"></div>
          </>
        </TopBar>
        <div className="flex grow">
          <SideMenu
            items={[
              {
                icon: <PackageSearch />,
                link: "/settings/products",
                title: "Produkte",
              },
              {
                icon: <Trophy />,
                link: "/settings/sales-ranks",
                title: "Verkaufsränge",
              },
              {
                icon: <User />,
                link: "/settings/users",
                title: "Benutzer",
              },
              {
                icon: <Calculator />,
                link: "/settings/numbers",
                title: "Berechnungen",
              },
              {
                icon: <MapPin />,
                link: "/settings/plz-routing",
                title: "PLZ-Routing",
              },
              {
                icon: <RefreshCw />,
                link: "/settings/wordpress-sync",
                title: "WordPress Sync",
              },
              /*{
                icon: <Webhook />,
                link: "/settings/webhooks",
                title: "Webhooks",
              },*/
            ]}
          />
          <div className="grow">{children}</div>
        </div>
      </BreadcrumbProvider>
    </div>
  );
};

export default SettingsRootComponent;
